import SvgIcon, { SvgIconProps } from "./SvgIcon";

const DeepDiveIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M9.35469 8.0918C9.35469 6.48855 8.06392 5.18886 6.47168 5.18886"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M3.58887 16.0273C3.58887 14.4241 4.87963 13.1244 6.47188 13.1244C6.97772 13.1244 7.45313 13.2556 7.86639 13.486"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M6.60718 13.0305C6.78306 12.3696 7.11741 11.794 7.55804 11.3342"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M11.8135 18.6452C11.8135 19.8908 10.8106 20.9004 9.5737 20.9004C8.38727 20.9004 7.41655 19.9717 7.33914 18.797C7.06514 18.8838 6.77375 18.9307 6.47193 18.9307C4.87929 18.9307 3.58848 17.6309 3.58848 16.0277C3.58848 15.3003 3.85378 14.6356 4.29304 14.1262C3.43366 13.8434 2.81348 13.0299 2.81348 12.0703C2.81348 11.1053 3.44148 10.2881 4.30782 10.0098C3.85987 9.49831 3.58848 8.82677 3.58848 8.09152C3.58848 6.48831 4.87929 5.18858 6.47193 5.18858C6.77202 5.18858 7.06166 5.23489 7.33392 5.32072C7.35218 4.09128 8.34812 3.10039 9.5737 3.10039C10.8106 3.10039 11.8135 4.11 11.8135 5.35554V18.6452Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M9.32246 17.1992C9.45464 16.7025 9.16196 16.1921 8.6688 16.059C8.44505 15.9986 8.21854 16.0262 8.02539 16.1209"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M11.8135 3.14453C16.7046 3.14453 20.6689 7.10891 20.6689 12C20.6689 16.8911 16.7046 20.8555 11.8135 20.8555"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M11.8135 9.16923C14.746 9.32719 16.5309 9.19218 19.101 6.96484"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M11.8135 14.8191C14.746 14.6611 16.5309 14.7961 19.101 17.0234"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
      <path
        d="M11.8135 3.14453C14.3938 3.14453 16.4843 7.10891 16.4843 12C16.4843 16.8911 14.3938 20.8555 11.8135 20.8555"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="white"
      />
    </SvgIcon>
  );
};

export default DeepDiveIcon;
